export default __webpack_public_path__ + "static/media/vdoffer2.3e285b2d.jpeg";